import React, { useState } from 'react';
import FoldRow from './FoldRow';

// HopeGoo (CJ) link panel: green brand bar, a title line and one chip per tracked link.
// items: [{ key, label, href, accent? }]
// collapsible：跟 Trip.com 嵌入框同頁時用，收合成一行中性樣式（FoldRow），點擊才展開連結。
// 傳入 open / onToggle 即由外層控制；否則自己記住展開狀態
const HopeGooPanel = ({ title, subtitle, items, collapsible = false, open, onToggle }) => {
  const [selfOpen, setSelfOpen] = useState(false);
  const chip = { textDecoration:'none', fontSize:12, fontWeight:800, color:'#0f172a', background:'#fff', border:'1.5px solid #1f9d5555', borderRadius:999, padding:'6px 12px' };
  const chips = (
    <div style={{ display:'flex', flexWrap:'wrap', gap:8 }}>
      {items.map(it => (
        <a key={it.key} href={it.href} target="_blank" rel="sponsored noopener noreferrer"
           style={it.accent ? { ...chip, color:'#1f9d55' } : chip}>
          {it.label}
        </a>
      ))}
    </div>
  );
  if (collapsible) {
    const controlled = open !== undefined;
    return (
      <FoldRow title={title} subtitle={subtitle} source="HopeGoo" sourceColor="#1f9d55"
        open={controlled ? open : selfOpen}
        onToggle={controlled ? onToggle : () => setSelfOpen(o => !o)}>
        {chips}
      </FoldRow>
    );
  }
  return (
    <div style={{ borderRadius:14, border:'1.5px solid #1f9d5540', background:'#1f9d5508', overflow:'hidden' }}>
      <div style={{ background:'#1f9d55', padding:'4px 12px' }}>
        <span style={{ color:'#fff', fontSize:10, fontWeight:900, textTransform:'uppercase', letterSpacing:1 }}>HopeGoo</span>
      </div>
      <div style={{ padding:'12px 14px', display:'flex', flexDirection:'column', gap:10 }}>
        <div>
          <p style={{ fontSize:13, fontWeight:900, color:'#0f172a', margin:'0 0 3px' }}>{title}</p>
          <span style={{ fontSize:11, color:'#f59e0b', fontWeight:700 }}>{subtitle}</span>
        </div>
        {chips}
      </div>
    </div>
  );
};

export default HopeGooPanel;
